import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import ReportingService from "Lib/API/reporting";
import useWidgetData from "./useWidgetData";
import WidgetWrapper from "./WidgetWrapper";
import "./widgets.scss";

const GRADE_COLORS = [
  { bg: "#EEF3FE", color: "#2563EB" },
  { bg: "#E8F8F1", color: "#1F9E6E" },
  { bg: "#FDF3E3", color: "#D4922B" },
  { bg: "#FDEEEC", color: "#C0392B" },
  { bg: "#F3E8FF", color: "#7C3AED" },
  { bg: "#FFF3E0", color: "#E65100" },
];

const gradeAbbr = (name) => {
  if (!name) return "?";
  const words = name.trim().split(/\s+/);
  if (words.length === 1) return name.slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
};

const SchoolEnrollmentWidget = ({ customizeMode, onRemove }) => {
  const history = useHistory();
  const fetcher = useCallback(
    (token) => ReportingService.getWidgetSchoolEnrollment(token),
    []
  );
  const { data, loading, error, retry } = useWidgetData(fetcher);

  const classes = data?.classes || [];

  const goToClass = (cls) => {
    if (customizeMode || !cls._id) return;
    history.push(`/class-participants/details/${cls._id}`);
  };

  return (
    <WidgetWrapper
      title="School Enrollment"
      loading={loading}
      error={error}
      onRetry={retry}
      customizeMode={customizeMode}
      onRemove={onRemove}
    >
      {classes.length === 0 ? (
        <div className="list-widget__empty">No school data available</div>
      ) : (
        <div className="widget-scroll-list" style={{ maxHeight: 400 }}>
          {classes.map((cls, i) => {
            const pct = cls.capacity ? Math.round((cls.enrolled / cls.capacity) * 100) : 0;
            const isFull = pct >= 90;
            const { bg, color } = GRADE_COLORS[i % GRADE_COLORS.length];
            const clickable = !customizeMode && !!cls._id;
            return (
              <div
                key={cls._id || i}
                className={`enroll-row${clickable ? " enroll-row--clickable" : ""}`}
                onClick={() => goToClass(cls)}
              >
                <div className="grade-icon" style={{ background: bg, color }}>{gradeAbbr(cls.name)}</div>
                <div className="enroll-name">{cls.name}</div>
                <div className="enroll-right">
                  <div className="enroll-right__count">{cls.enrolled}{cls.capacity > 0 ? `/${cls.capacity}` : ""}</div>
                  {cls.capacity > 0 && (
                    <div className="prog-bar" style={{ marginTop: 3 }}>
                      <div
                        className={`prog-bar__fill${isFull ? " prog-bar__fill--red" : " prog-bar__fill--blue"}`}
                        style={{ width: `${Math.min(pct, 100)}%` }}
                      />
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </WidgetWrapper>
  );
};

export default SchoolEnrollmentWidget;
